export const mapErrorsMsg = (error) => {
  const { graphQLErrors } = error
  if (Array.isArray(graphQLErrors)) {
    const msg = graphQLErrors.map((err) => err.message).join(',')
    return msg
  }
  return 'Error from server'
}
